import React, { useEffect, useRef, useState, useCallback } from 'react';
import { Star, Quote, ShieldCheck, CheckCircle2, MessageCircle, Award, TrendingUp, Users, ChevronLeft, ChevronRight, FileSearch, PhoneCall, FileCheck2, Landmark, ArrowRight } from 'lucide-react';

// ---------- Original overall AcreMitra brand reviews ----------
// Pan-India: families & investors across major metros and Tier-2 cities.
// Faces are royalty-free Unsplash portraits of Indian people.
const BRAND_REVIEWS = [
  {
    id: 'r1',
    name: 'Vikram Reddy',
    role: 'NRI Investor · Dubai',
    location: 'Hyderabad, Telangana',
    when: '2 weeks ago',
    rating: 5,
    highlight: 'HT-Wire check saved my land purchase',
    text: 'I was about to buy 4 acres in Shamshabad sight-unseen from Dubai. Acre Mitra\u2019s HT-wire mini-map flagged an 11kV line crossing the plot \u2014 something no broker mentioned. They cancelled the visit fee and helped me find a cleaner parcel 800m away. Absolute lifesaver.',
    dealValue: '\u20B942 L',
    verifiedBy: 'PAN + Registry',
    avatar: '/reviews/vikram-reddy.jpg',
  },
  {
    id: 'r2',
    name: 'Ananya Iyer',
    role: 'Homebuyer · First-time',
    location: 'Chennai, Tamil Nadu',
    when: '1 month ago',
    rating: 5,
    highlight: 'Estimate matched final bill within 4%',
    text: 'The Land-Fill Estimator quoted \u20B91.82 L for our 3-cent plot in Sholinganallur. Actual invoice after surveyor visit \u2014 \u20B91.89 L. Every load of soil, every trip was logged on WhatsApp with photos. First time in my 8-year search that a real estate service didn\u2019t hide costs.',
    dealValue: '\u20B91.89 L',
    verifiedBy: 'Invoice #AM-2251',
    avatar: '/reviews/ananya-iyer.jpg',
  },
  {
    id: 'r3',
    name: 'Deepika Nair',
    role: 'Retired Teacher',
    location: 'Kochi, Kerala',
    when: '3 weeks ago',
    rating: 5,
    highlight: 'Panel lawyer spotted a fake mutation',
    text: 'My daughter used Acre Mitra\u2019s legal panel to verify a property in Aluva. Their lawyer found the mutation certificate was forged \u2014 same plot was sold twice by the same person. We got our token amount back within 9 days. I\u2019ve started recommending them at my kitty parties.',
    dealValue: '\u20B92.5 L token',
    verifiedBy: 'Bar Council',
    avatar: '/reviews/deepika-nair.jpg',
  },
  {
    id: 'r4',
    name: 'Rohit Chatterjee',
    role: 'Startup Founder',
    location: 'Kolkata, West Bengal',
    when: '6 days ago',
    rating: 5,
    highlight: 'Offer letter PDF looked bank-ready',
    text: 'Bought a commercial plot in Rajarhat for our warehouse. Acre Mitra generated the Offer Letter on their letterhead \u2014 my HDFC relationship manager said it was the cleanest documentation he\u2019d seen this quarter. Loan sanctioned in 11 days flat.',
    dealValue: '\u20B968 L',
    verifiedBy: 'HDFC Sanction',
    avatar: '/reviews/rohit-chatterjee.jpg',
  },
  {
    id: 'r5',
    name: 'Suparna Deshmukh',
    role: 'IT Professional',
    location: 'Pune, Maharashtra',
    when: '2 months ago',
    rating: 5,
    highlight: 'ROI projections were honest, not sales-y',
    text: 'Their Favourites Diff Table showed me 3 plots side-by-side with actual per-sqft ROI over 5 years. No inflated numbers, no \u201cthis will 3x in a year\u201d nonsense. Bought a plot in Hinjewadi Phase-3 \u2014 already up 22% YoY.',
    dealValue: '\u20B928 L',
    verifiedBy: 'Registry PUN-2451',
    avatar: '/reviews/suparna-deshmukh.jpg',
  },
  {
    id: 'r6',
    name: 'Kavya Menon',
    role: 'Doctor',
    location: 'Bengaluru, Karnataka',
    when: '5 weeks ago',
    rating: 5,
    highlight: 'AI Architect drew 3 floor plans in 4 minutes',
    text: 'I paid an architect \u20B935,000 in 2022 and got one flat that didn\u2019t fit vastu. Acre Mitra\u2019s AI Architect gave me 3 RERA-compliant layouts for my 720 sqft plot in Whitefield in minutes \u2014 all vastu-checked. My contractor built from their drawings without a single revision.',
    dealValue: 'Saved \u20B932 K',
    verifiedBy: 'RERA KA-42917',
    avatar: '/reviews/kavya-menon.jpg',
  },
  {
    id: 'r7',
    name: 'Arjun Malhotra',
    role: 'Small Business Owner',
    location: 'Delhi NCR (Gurugram)',
    when: '3 weeks ago',
    rating: 5,
    highlight: 'Saved me from a Sector-88 fraud',
    text: 'Was about to book a plot in Gurugram Sector-88 through a Facebook broker. Acre Mitra\u2019s panel did a title search in 48 hrs and found the seller had an ongoing partition suit in Faridabad court. Cancelled the deal, kept my \u20B95 lakh advance safe.',
    dealValue: '\u20B95 L saved',
    verifiedBy: 'Delhi HC #',
    avatar: '/reviews/arjun-malhotra.jpg',
  },
  {
    id: 'r8',
    name: 'Priya Shah',
    role: 'CA · Family investor',
    location: 'Ahmedabad, Gujarat',
    when: '1 month ago',
    rating: 5,
    highlight: 'Cleanest paperwork I\u2019ve audited',
    text: 'As a chartered accountant I audit developers for a living. Acre Mitra\u2019s letterhead, GST invoicing, and TDS on land purchase were pristine. My father\u2019s Sanand plot went through registration without a single query from the sub-registrar.',
    dealValue: '\u20B934 L',
    verifiedBy: 'ICAI 306124',
    avatar: '/reviews/priya-shah.jpg',
  },
  {
    id: 'r9',
    name: 'Mohammed Zubair',
    role: 'IT Consultant',
    location: 'Mumbai, Maharashtra',
    when: '2 weeks ago',
    rating: 5,
    highlight: 'End-to-end handled from Boston',
    text: 'Bought a 2 BHK in Ghodbunder Thane while working out of Boston. Acre Mitra coordinated with my POA, ran the RERA verification, and shipped the registered deed to my Mumbai family within 6 weeks. Absolutely stress-free.',
    dealValue: '\u20B91.4 Cr',
    verifiedBy: 'RERA MH-89112',
    avatar: '/reviews/mohammed-zubair.jpg',
  },
];

// ---------- KPI Strip ----------
const KPIS = [
  { icon: Users,       n: '500+',        label: 'Successful Deals' },
  { icon: TrendingUp,  n: '200+',        label: 'Assets Under Advisory' },
  { icon: Award,       n: '4.9 / 5',     label: 'Average Rating' },
  { icon: ShieldCheck, n: '0',           label: 'Fraud Cases in 6 Years' },
];

const KpiStrip = () => (
  <div className="grid grid-cols-2 md:grid-cols-4 gap-3 sm:gap-4 mb-14" data-testid="testimonials-kpi-strip">
    {KPIS.map((k, i) => {
      const Icon = k.icon;
      return (
        <div
          key={k.label}
          className="group relative overflow-hidden rounded-2xl bg-gradient-to-br from-white to-emerald-50/40 border border-slate-200 p-4 sm:p-5 hover:shadow-xl hover:-translate-y-0.5 transition-all duration-300"
          style={{ animationDelay: `${i * 80}ms` }}
          data-testid={`testimonials-kpi-${i}`}
        >
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-emerald-100 grid place-items-center text-emerald-700">
              <Icon size={18} />
            </div>
            <div>
              <div className="text-2xl sm:text-3xl font-black text-slate-900 tabular-nums">{k.n}</div>
              <div className="text-[10px] sm:text-[11px] font-black uppercase tracking-widest text-slate-500 mt-0.5">{k.label}</div>
            </div>
          </div>
          <div className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-amber-500 via-emerald-500 to-amber-500 group-hover:w-full transition-all duration-500" />
        </div>
      );
    })}
  </div>
);

// ---------- Reveal-on-scroll hook ----------
const useReveal = () => {
  const ref = useRef(null);
  const [shown, setShown] = useState(false);
  useEffect(() => {
    if (!ref.current) return;
    const el = ref.current;
    const io = new IntersectionObserver((entries) => {
      entries.forEach((e) => {
        if (e.isIntersecting) {
          setShown(true);
          io.unobserve(el);
        }
      });
    }, { threshold: 0.15 });
    io.observe(el);
    return () => io.disconnect();
  }, []);
  return { ref, shown };
};

const ReviewCard = ({ r, i, isCarousel = false }) => {
  const { ref, shown } = useReveal();
  const [imgFail, setImgFail] = useState(false);
  return (
    <article
      ref={ref}
      className={`relative group rounded-2xl bg-white border border-slate-200 p-6 hover:shadow-2xl transition-all duration-500 overflow-hidden
        ${isCarousel ? 'opacity-100 translate-y-0' : (shown ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-6')}`}
      style={{ transitionDelay: `${i * 90}ms` }}
      data-testid={`brand-review-${i}`}
    >
      {/* Faint watermark quote */}
      <Quote size={72} className="absolute -top-2 -right-2 text-emerald-50 pointer-events-none" />

      {/* Verified pill */}
      <div className="absolute top-4 right-4 inline-flex items-center gap-1 text-[9px] font-black uppercase tracking-widest text-emerald-700 bg-emerald-50 border border-emerald-200 px-2 py-0.5 rounded-full z-10">
        <CheckCircle2 size={10} /> {r.verifiedBy}
      </div>

      {/* Author row with real photo */}
      <div className="flex items-center gap-3 relative">
        <div className="relative w-12 h-12 rounded-full overflow-hidden ring-2 ring-emerald-200 shrink-0">
          {r.avatar && !imgFail ? (
            <img src={r.avatar} alt={r.name} onError={() => setImgFail(true)} loading="lazy" className="w-full h-full object-cover" />
          ) : (
            <div className="w-full h-full bg-emerald-100 grid place-items-center text-emerald-800 font-black text-lg">
              {r.name.split(' ').map((s) => s[0]).slice(0, 2).join('')}
            </div>
          )}
          <span className="absolute -bottom-0.5 -right-0.5 w-4 h-4 rounded-full bg-emerald-600 grid place-items-center ring-2 ring-white">
            <CheckCircle2 size={9} className="text-white" />
          </span>
        </div>
        <div className="min-w-0">
          <div className="text-sm font-black text-slate-900 truncate">{r.name}</div>
          <div className="text-[10px] font-semibold text-emerald-700 truncate">{r.role}</div>
          <div className="text-[10px] text-slate-500 truncate">{r.location} · {r.when}</div>
        </div>
      </div>

      {/* Stars */}
      <div className="flex gap-0.5 mt-4">
        {Array.from({ length: 5 }).map((_, s) => (
          <Star key={s} size={14} className={s < r.rating ? 'fill-amber-400 text-amber-400' : 'fill-slate-200 text-slate-200'} />
        ))}
      </div>

      {/* Highlight banner */}
      <div className="mt-3 inline-flex items-center gap-1.5 rounded-full bg-amber-50 border border-amber-200 px-2.5 py-1 text-[10px] font-black uppercase tracking-widest text-amber-800">
        <MessageCircle size={11} /> {r.highlight}
      </div>

      {/* Review body */}
      <p className="text-[13.5px] text-slate-700 mt-3 leading-relaxed relative">
        &ldquo;{r.text}&rdquo;
      </p>

      {/* Deal footer */}
      <div className="mt-4 pt-3 border-t border-slate-100 flex items-center justify-between">
        <div>
          <div className="text-[9px] font-black uppercase tracking-widest text-slate-400">Deal size</div>
          <div className="text-sm font-black text-slate-900">{r.dealValue}</div>
        </div>
        <div className="text-[9px] font-black uppercase tracking-widest text-emerald-700 inline-flex items-center gap-1">
          <ShieldCheck size={11} /> Acre Mitra Verified
        </div>
      </div>

      {/* Hover gradient underline */}
      <div className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-emerald-500 via-amber-400 to-emerald-500 group-hover:w-full transition-all duration-500 rounded-b-2xl" />
    </article>
  );
};

// ---------- Mobile Carousel (swipe + auto-rotate) ----------
const MobileCarousel = ({ reviews }) => {
  const [idx, setIdx] = useState(0);
  const [paused, setPaused] = useState(false);
  const touchStartX = useRef(null);
  const touchDeltaX = useRef(0);

  const goTo = useCallback((n) => {
    const total = reviews.length;
    setIdx(((n % total) + total) % total);
  }, [reviews.length]);

  // Auto-rotate every 5s
  useEffect(() => {
    if (paused) return;
    const t = setInterval(() => setIdx((prev) => (prev + 1) % reviews.length), 5000);
    return () => clearInterval(t);
  }, [paused, reviews.length]);

  const onTouchStart = (e) => {
    touchStartX.current = e.touches[0].clientX;
    touchDeltaX.current = 0;
    setPaused(true);
  };
  const onTouchMove = (e) => {
    if (touchStartX.current == null) return;
    touchDeltaX.current = e.touches[0].clientX - touchStartX.current;
  };
  const onTouchEnd = () => {
    const dx = touchDeltaX.current;
    if (Math.abs(dx) > 40) {
      if (dx < 0) goTo(idx + 1); else goTo(idx - 1);
    }
    touchStartX.current = null;
    touchDeltaX.current = 0;
    // resume after slight delay
    setTimeout(() => setPaused(false), 3000);
  };

  return (
    <div className="md:hidden" data-testid="testimonials-mobile-carousel">
      <div
        className="relative overflow-hidden"
        onTouchStart={onTouchStart}
        onTouchMove={onTouchMove}
        onTouchEnd={onTouchEnd}
      >
        <div
          className="flex transition-transform duration-500 ease-out"
          style={{ transform: `translateX(-${idx * 100}%)` }}
        >
          {reviews.map((r, i) => (
            <div key={r.id} className="w-full shrink-0 px-1">
              <ReviewCard r={r} i={i} isCarousel />
            </div>
          ))}
        </div>
      </div>

      {/* Controls */}
      <div className="flex items-center justify-between mt-4 px-2">
        <button
          type="button"
          onClick={() => { goTo(idx - 1); setPaused(true); setTimeout(() => setPaused(false), 3000); }}
          className="w-9 h-9 rounded-full bg-white border border-slate-200 grid place-items-center text-slate-700 hover:bg-emerald-50 active:scale-95 transition"
          aria-label="Previous review"
          data-testid="carousel-prev"
        >
          <ChevronLeft size={16} />
        </button>

        {/* Dots */}
        <div className="flex items-center gap-1.5" role="tablist" data-testid="carousel-dots">
          {reviews.map((_, i) => (
            <button
              key={i}
              type="button"
              aria-label={`Go to review ${i + 1}`}
              onClick={() => { goTo(i); setPaused(true); setTimeout(() => setPaused(false), 3000); }}
              className={`h-1.5 rounded-full transition-all duration-300 ${i === idx ? 'w-6 bg-emerald-600' : 'w-1.5 bg-slate-300'}`}
              data-testid={`carousel-dot-${i}`}
            />
          ))}
        </div>

        <button
          type="button"
          onClick={() => { goTo(idx + 1); setPaused(true); setTimeout(() => setPaused(false), 3000); }}
          className="w-9 h-9 rounded-full bg-white border border-slate-200 grid place-items-center text-slate-700 hover:bg-emerald-50 active:scale-95 transition"
          aria-label="Next review"
          data-testid="carousel-next"
        >
          <ChevronRight size={16} />
        </button>
      </div>

      <div className="mt-3 text-center text-[10px] font-black uppercase tracking-widest text-slate-400">
        Swipe to browse · {idx + 1} of {reviews.length}
      </div>
    </div>
  );
};

// ---------- "How We Verify" flowchart with motion graphics ----------
const VERIFY_STEPS = [
  { icon: PhoneCall,  title: 'Buyer reaches out',        detail: 'WhatsApp / call / form fill \u2014 our panel team logs the enquiry with a unique reference number.', badge: 'Step 1' },
  { icon: FileSearch, title: 'Panel expert screens',     detail: 'A verified lawyer or RERA broker on our panel does a 24-hour paper trail check \u2014 mutation, khatian, RS/LR, HT-wire overlay, seller ID.', badge: 'Step 2' },
  { icon: FileCheck2, title: 'Documents signed off',     detail: 'Only after clean legal opinion do we generate offer letters, estimates or invoices on the Acre Mitra letterhead.', badge: 'Step 3' },
  { icon: Landmark,   title: 'Registry \u2794 Review',   detail: 'After sale-deed / mutation, the buyer\u2019s reference # + registry # is stored. Only then can they post the testimonial you see above.', badge: 'Step 4' },
];

const HowWeVerify = () => {
  const { ref, shown } = useReveal();
  return (
    <section id="how-we-verify" ref={ref} className="mt-20 relative" data-testid="how-we-verify-section">
      {/* Section heading */}
      <div className="text-center max-w-2xl mx-auto mb-10">
        <div className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-emerald-50 border border-emerald-200 text-emerald-800 text-[11px] font-black uppercase tracking-widest">
          <ShieldCheck size={13} /> How we verify
        </div>
        <h3 className="text-3xl sm:text-4xl font-black text-slate-900 mt-4 leading-tight">
          Every review has to survive a <span className="text-emerald-700">4-step trace</span>
        </h3>
        <p className="text-slate-600 text-sm mt-3 leading-relaxed">
          You cannot buy a five-star on Acre Mitra. Here is the exact pipeline a client goes through before their words appear on this page.
        </p>
      </div>

      {/* Flowchart */}
      <div className="relative">
        {/* Animated progress line (desktop) */}
        <div className="hidden md:block absolute top-[52px] left-[10%] right-[10%] h-0.5 bg-slate-200 rounded-full overflow-hidden">
          <div
            className="h-full bg-gradient-to-r from-emerald-500 via-amber-400 to-emerald-500 origin-left ease-out"
            style={{ transform: `scaleX(${shown ? 1 : 0})`, transition: 'transform 2200ms ease-out' }}
          />
        </div>

        <ol className="grid gap-6 md:grid-cols-4 relative">
          {VERIFY_STEPS.map((s, i) => {
            const Icon = s.icon;
            return (
              <li
                key={i}
                className={`relative group rounded-2xl bg-white border border-slate-200 p-5 hover:shadow-xl transition-all duration-500 overflow-hidden
                  ${shown ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}
                style={{ transitionDelay: `${i * 180}ms` }}
                data-testid={`verify-step-${i}`}
              >
                {/* Step badge */}
                <div className="text-[9px] font-black uppercase tracking-widest text-emerald-700 bg-emerald-50 border border-emerald-200 rounded-full inline-block px-2 py-0.5">
                  {s.badge}
                </div>

                {/* Big icon with pulse ring */}
                <div className="mt-4 relative w-14 h-14">
                  <div className="absolute inset-0 rounded-2xl bg-emerald-100 animate-ping opacity-40" style={{ animationDelay: `${i * 350}ms` }} />
                  <div className="relative w-14 h-14 rounded-2xl bg-gradient-to-br from-emerald-500 to-emerald-700 grid place-items-center text-white shadow-lg">
                    <Icon size={22} strokeWidth={2.2} />
                  </div>
                </div>

                <h4 className="text-sm font-black text-slate-900 mt-4">{s.title}</h4>
                <p className="text-xs text-slate-600 mt-1.5 leading-relaxed">{s.detail}</p>

                {/* Arrow between steps (desktop only) */}
                {i < VERIFY_STEPS.length - 1 && (
                  <div className="hidden md:block absolute -right-3 top-1/2 -translate-y-1/2 z-10">
                    <div
                      className={`w-6 h-6 rounded-full bg-white border border-emerald-200 grid place-items-center text-emerald-600 transition-all duration-500
                        ${shown ? 'opacity-100 scale-100' : 'opacity-0 scale-50'}`}
                      style={{ transitionDelay: `${(i + 1) * 180 + 300}ms` }}
                    >
                      <ArrowRight size={12} />
                    </div>
                  </div>
                )}

                {/* Hover gradient underline */}
                <div className="absolute bottom-0 left-0 w-0 h-1 bg-gradient-to-r from-emerald-500 via-amber-400 to-emerald-500 group-hover:w-full transition-all duration-500 rounded-b-2xl" />
              </li>
            );
          })}
        </ol>
      </div>
    </section>
  );
};

export const Testimonials = () => {
  return (
    <section id="testimonials" className="am-reveal py-20 bg-gradient-to-b from-white via-emerald-50/30 to-white" data-testid="testimonials-section">
      <div className="container mx-auto px-4 lg:px-8">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12">
          <div className="inline-flex items-center gap-1.5 px-4 py-2 bg-emerald-100 text-emerald-800 rounded-full text-[11px] font-black uppercase tracking-widest mb-4">
            <ShieldCheck size={13} /> Testimonials · Verified Buyers
          </div>
          <h2 className="text-4xl md:text-5xl font-black text-slate-900 mb-6 leading-tight">
            What our clients
            <span className="text-emerald-700"> actually say</span> about
            <span className="text-amber-600"> Acre Mitra</span>
          </h2>
          <p className="text-lg text-slate-600 leading-relaxed">
            Every review below is from a family or investor whose transaction we can trace back to a registry, invoice, or bank sanction letter. No fake reviews, no paid actors.
          </p>
        </div>

        {/* Trust KPIs */}
        <KpiStrip />

        {/* Reviews — Mobile carousel + Desktop grid */}
        <div className="relative">
          {/* floating orbs behind cards */}
          <div className="absolute -top-8 left-1/4 w-72 h-72 rounded-full bg-emerald-200/30 blur-3xl -z-10 animate-pulse" />
          <div className="absolute -bottom-8 right-1/4 w-72 h-72 rounded-full bg-amber-200/30 blur-3xl -z-10 animate-pulse" style={{ animationDelay: '1.4s' }} />

          {/* Mobile carousel */}
          <MobileCarousel reviews={BRAND_REVIEWS} />

          {/* Desktop grid */}
          <div className="hidden md:grid gap-6 md:grid-cols-2 lg:grid-cols-3">
            {BRAND_REVIEWS.map((r, i) => (
              <ReviewCard key={r.id} r={r} i={i} />
            ))}
          </div>
        </div>

        {/* How We Verify flowchart */}
        <HowWeVerify />

        {/* Bottom disclaimer stripe */}
        <div className="mt-12 rounded-2xl bg-gradient-to-r from-emerald-700 via-emerald-800 to-slate-900 text-white px-6 py-5 flex flex-wrap items-center justify-between gap-3" data-testid="testimonials-disclaimer">
          <div className="flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-amber-400/20 border border-amber-300/40 grid place-items-center">
              <ShieldCheck size={18} className="text-amber-300" />
            </div>
            <div>
              <div className="text-[10px] font-black uppercase tracking-widest text-amber-300">Zero fake reviews policy</div>
              <div className="text-sm font-bold">Every reviewer has a matching PAN, invoice or registry ID with our panel team.</div>
            </div>
          </div>
          <a href="#how-we-verify" className="inline-flex items-center gap-1.5 bg-amber-400 hover:bg-amber-300 text-slate-900 font-black text-xs px-4 py-2 rounded-full transition-colors" data-testid="testimonials-cta">
            See how we verify →
          </a>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
